type GetMyLearningRedirectUrlArgs = {
  enableProgramRedirectToMyLearning: boolean;
  programSlug?: string | null;
  orgSlug?: string | null;
  pathname?: string | null;
};

// Programs opted into enableProgramRedirectToMyLearning (e.g. Pearson's LTI-linked programs, see
// LRNRSCCSS-6546) send learners straight to org-scoped My Learning instead of preserving the
// requested program-scoped subpath, regardless of the broader org-scoped-home rollout state.
export const getMyLearningRedirectUrl = ({
  enableProgramRedirectToMyLearning,
  programSlug,
  orgSlug,
  pathname,
}: GetMyLearningRedirectUrlArgs): string | null => {
  if (!enableProgramRedirectToMyLearning || !programSlug || !orgSlug) {
    return null;
  }

  const programPrefix = `/programs/${programSlug}`;
  const isProgramScopedPath = pathname === programPrefix || Boolean(pathname?.startsWith(`${programPrefix}/`));

  return isProgramScopedPath ? `/organizations/${orgSlug}/my-learning` : null;
};
